import { useQuery } from "@tanstack/react-query"
import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"

type Props = {
  orderId?: string
  includePayments?: boolean
}

export const useOrder = (props: Props) => {
  return useQuery({
    queryKey: [queryKeys.ORDER, props.orderId],
    queryFn: () => fetchOrder(props.orderId, { includePayments: props.includePayments }),
    gcTime: 0,
    enabled: !!props.orderId,
  })
}

const fetchOrder = async (orderId?: string, options: { includePayments?: boolean } = {}) => {
  if (!orderId) return

  const filteredOptions = Object.fromEntries(Object.entries(options).filter(([_, value]) => value !== undefined))

  try {
    return await api2.Orders.fetch(orderId, false, filteredOptions)
  } catch (error) {
    console.error("Error fetching order:", error)
    throw error
  }
}
